import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort, Sort } from "@angular/material/sort";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { DomSanitizer } from "@angular/platform-browser";
import { Subject } from "rxjs";
import { tableEventChange } from "../table-utils/classes/tableChangeEvent";
import { DELETE_ICON, DETAILS_ICON, EDIT_ICON } from "../table-utils/custom-svgs/custom-svgs";
import { columnType } from "../table-utils/enums/columnType";


@Component({
  selector: "app-table-template",
  templateUrl: "./table-template.component.html"
})
export class TableComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<any>;

  @Output() actionEvent = new EventEmitter<any>();
  @Output() tableChangeEvent = new EventEmitter<tableEventChange>();

  @Output() clickEvent = new EventEmitter<any>();

  @Input() columns : {
    data : {
      title: string;
      type: columnType
    }[],
    clickable : boolean;
    };
  @Input() formattedData$: Subject<any>;
  @Input() totalLength$: Subject<any>;

  columnsToDisplay: string[];

  isLoadingResults = true;
  resultsLength : number = 0;
  formattedData =  new MatTableDataSource<any>();

  currentPageSize : number;
  currentSort : {
    active: string,
    direction: string
  }
  empty : boolean;
  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    iconRegistry.addSvgIconLiteral('EDIT', sanitizer.bypassSecurityTrustHtml(EDIT_ICON));
    iconRegistry.addSvgIconLiteral('DETAILS', sanitizer.bypassSecurityTrustHtml(DETAILS_ICON));
    iconRegistry.addSvgIconLiteral('DELETE', sanitizer.bypassSecurityTrustHtml(DELETE_ICON));
  }

  ngOnInit(): void {
    this.columnsToDisplay = this.columns.data.map(
      (column) => {
        if (column.type !== columnType.id) {
          return column.title
        }
      }
    );
    this.totalLength$.subscribe(length => {
      this.resultsLength = length;
    });
    this.formattedData$.subscribe(data => {
      this.formattedData.data = data;
      this.empty = this.formattedData.data.length === 0;
    });
  }

  ngAfterViewInit(): void {
    this.currentPageSize = this.paginator.pageSize;
  }

  emitAction(action : any) : void {
    this.actionEvent.emit(action);
  }

  emitPaginatorChange(event : PageEvent) : void {
    if (this.currentPageSize !== event.pageSize) {
      event.pageIndex = 0;
      this.currentPageSize = event.pageSize;
      this.paginator.pageIndex = 0;
    }
    const currentSort : Sort = {
      active : this.sort.active,
      direction : this.sort.direction
    };
    const dataToEmit : tableEventChange = {
      sortEvent : currentSort,
      pageIndex : this.paginator.pageIndex,
      pageSize : this.paginator.pageSize
    }
    this.tableChangeEvent.emit(dataToEmit);
  }

  emitSort(event : Sort) : void {
    const dataToEmit : tableEventChange = {
      sortEvent : event,
      pageIndex : this.paginator.pageIndex,
      pageSize : this.paginator.pageSize
    }
    this.tableChangeEvent.emit(dataToEmit);
  }

  rowClick(row) : void {
    this.clickEvent.emit(row.id);
  }

}
